import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { AboutPageComponent } from './pages/about-page/about-page.component';
import { SandscriptComponent } from './pages/sandscript/sandscript.component';
import { SandservicesComponent } from './pages/sandservices/sandservices.component';
import { MyTodoPageComponent } from './pages/my-todo-page/my-todo-page.component';
import { MapperanywhereComponent } from './pages/mapperanywhere/mapperanywhere.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: HomePageComponent
  },
  {
    path: 'mapperanywhere',
    component: MapperanywhereComponent
  },
  {
    path: 'sandscript',
    component: SandscriptComponent
  },
  {
    path: 'sandservices',
    component: SandservicesComponent
  },
  {
    path: 'about',
    component: AboutPageComponent
  },
  {
    path: 'todo',
    component: MyTodoPageComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
